<template>
  <div class="d-flex align-items-center min-vh-100">
    <CContainer fluid>
      <CRow class="justify-content-center">
        <CCol md="6">
          <CCard class="mx-4 mb-0">
            <CCardBody class="p-4">
              <CForm>
                <p>
                  {{msg}}
                </p>
                <CCol md="12" v-if="msg !== ''">
                  <center>
                    <CButton color="primary" block to="/login">Efetuar login</CButton>
                  </center>
                </CCol>
              </CForm>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
export default {
  name: 'Register',
  data () {
    return {
      msg: '',
    }
  },
  mounted() {
    this.check()
  },
  methods: {
    check() {
      let url = this.$route.query.queryURL
      this.$http.get(url)
      .then(res => {
        //alert(res.status)
        if (res.status === 403)
        {
          this.msg = 'Link de validação inválido.'
          return false
        } else if (res.status ===  429) {
          this.msg = 'Muitas tentativas de validação. Tente novamente em alguns instantes.'
          return false
        } else if (res.status ===  204 || res.status === 200) {
          this.$swal({
            icon: 'success',
            title: 'Tudo certo!',
            text: 'Email validado com sucesso.',
          })
          this.$router.push({name: 'Dashboard'})
        }
      })
      .catch(error => {
        console.log('erro', error)
      });
    }
  }
}
</script>
